import { createFileRoute, redirect } from '@tanstack/react-router'

import { signOut } from '@/shared/auth/utils/router'

export const Route = createFileRoute('/_auth/logout')({
	beforeLoad: async ({ context: { clerk } }) => {
		if (!clerk.client) return

		await signOut({ clerk: clerk.client })

		throw redirect({
			to: '/login',
			replace: true,
		})
	},
})
